export const getVersion = () => document.querySelector('meta[name="version"]').content;
